export const I18N_SETTING = [
  {
    value: "en",
    label: "English",
    label_en: "English",
    label_zh: "英語",
    public: true,
  },
  {
    value: "zh-tw",
    label: "繁體中文",
    label_en: "Traditional Chinese",
    label_zh: "繁體中文",
    public: true,
  },
  {
    value: "fr",
    label: "français",
    label_en: "française",
    label_zh: "法語",
    public: false, // 是否開放
  },
];

export const LOCALE_LANG = {
  LOCALE_DEFAULT: "zh-tw",
  LOCALE_ZH: "zh-tw",
  LOCALE_EN: "en",
};
